export default __webpack_public_path__ + "static/media/appline.d0ff37aa.svg";